<template>
  <div
    :class="[b(), { isOverseasCollapse: isOverseasVersion && showAsideCollapse }]"
  >
    <menu-hide-tip
      v-if="isHideModel && isValidRoute"
      :current-model="currentModel"
    ></menu-hide-tip>
    <div
      v-if="visibleBanner && !isAnonymous"
      :class="b('alert')"
    >
      <ValueReachBanner
        :item="milestoneWorthMsg"
        @close="handleClose"
      />
    </div>

    <SubscriptionBanner
      :show-aside="showAside"
      :banner-v-o-s="bannerVOS"
    />

    <el-container
      direction="horizontal"
      :class="b('container')"
    >
      <LeftAside
        v-if="renderAside"
        v-show="showAside"
        :collapse.sync="collapse"
        :micro-app-name="currentAppName"
      />
      <el-container
        direction="vertical"
        :class="b('wrap')"
      >
        <el-header
          v-if="showHeader"
          height="50px"
          :class="b('wrap-header')"
        >
          <TopNav
            :micro-app-name="currentAppName"
          />
        </el-header>
        <el-main
          :style="{ background }"
          :class="[b('main'), { 'is-simple': isSimple }]"
        >
          <template v-if="!isMicroApp">
            <keep-alive>
              <router-view v-if="keepAlive" />
            </keep-alive>
            <router-view v-if="!keepAlive" />
          </template>
          <!--  微前端子应用懒加载 -->
          <micro-app
            v-for="app of microApps"
            :key="app.name"
            :app="app"
            @active="onMicroActive"
          />
        </el-main>
      </el-container>
    </el-container>

    <LeftContent :collapse="collapse" />
  </div>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import microApps from '@/router/microApps';
import { prefetchApps, start } from 'qiankun';
import MicroApp from '@/components/MicroApp';
import { isNil } from 'lodash';
import LeftAside from '@/layouts/components/LeftAside';
import TopNav from './components/menu/TopNav';
// import { getCache } from '@zk/framework-vue';
import ValueReachBanner from '@/layouts/components/drawer/msg/ValueReachBanner.mine.vue';
import {
  queryMilestoneWorthMsg
} from '@/api/guide';
import SubscriptionBanner from './components/drawer/msg/SubscriptionBanner';
import { showGuideIfNeeded } from './uiGuide';
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex';
import { isOverseasVersion } from 'common-module/src/util';
import { findDownComponent } from '@zk/framework-vue';
import LeftContent from '@/components/float-btn/LeftContent.vue';
import menuHideTip from '@/layouts/components/MenuHideTip.vue';
import { BroadcastChannel } from 'broadcast-channel';
const menuChannel = new BroadcastChannel('menu-channel');
import { onKeyStroke } from '@vueuse/core';

export default {
  name: 'DefaultLayout',
  components: {
    TopNav,
    ValueReachBanner,
    LeftAside,
    MicroApp,
    SubscriptionBanner,
    LeftContent,
    menuHideTip
  },
  provide() {
    return {
      appLayout: this
    };
  },
  bemNS: theme.bemNS,
  socketEvents: {
    sprintUpdate(data) {
      const { sprintVO } = data;
      this.$store.commit('sprint/SET_SPRINT_LIST_CHANGE', sprintVO.projectId);
    },
    sprintAdd(data) {
      const { sprintVO } = data;
      this.$store.commit('sprint/SET_SPRINT_LIST_CHANGE', sprintVO.projectId);
    },
    sprintDelete(data) {
      this.$store.commit('sprint/SET_SPRINT_LIST_CHANGE', data.projectId);
    },
    /**
     * 项目成员更新
     * @returns {Promise<void>}
     */
    projectUserOpt(data) {
      // 项目协作者
      if (data?.operateType === 3) {
        const project = this.$store.getters['app/currentProject'];
        if (data.projectId === project?.id) {
          return this.$router.push('/project/list');
        }
      }
      this.onProjectAccessUpdate(data);
      // 项目协作者变更
    },
    /**
     * 角色更新
     * @returns {Promise<void>}
     */
    rolePermissionUpdate(data) {
      if (data?.existsPermissions['10200'] !== data?.permissionsToUpdate['10200']){
        this.onProjectAccessUpdate();
      }
    },
    'global:rightPush'(data) {
      const result = data.result;
      if (result.bannerVOs) {
        this.bannerVOS = result.bannerVOs;
      }
      if (result.rightVOS) {
        this.SET_PRODUCT_RIGHTS(result.rightVOS);
      }
    },
    tenantRightChange(data) {
      // console.log(7777777, data);
      if (data.rightVOS) {
        this.SET_PRODUCT_RIGHTS(data.rightVOS);
      }
    }
  },
  shortcutsEvents() {
    const openDashboard = (keyName) => {
      if (!this.checkMenuVisible('dashboard')) {
        return;
      }
      this.$router.push({ name: 'dashboard', params: { from: 'ShortcutsEvents' } });
      this.$track.send('Hotkeys', {
        Hotkeys_Scope: '全局',
        Hotkeys_Name: keyName,
        Hotkeys_Path: this.$route.path,
        Has_Dialog: false
      }, true);
    };

    const openWorkList = (keyName) => {
      if (!this.checkMenuVisible('work_list') && !this.showWorkList) {
        return;
      }
      this.$router.push('/work/list');
      this.$track.send('Hotkeys', {
        Hotkeys_Scope: '全局',
        Hotkeys_Name: keyName,
        Hotkeys_Path: this.$route.path,
        Has_Dialog: false
      }, true);
    };

    return [
      {
        key: ['g', 'd'],
        type: 'global',
        callback: () => openDashboard('G+D')
      },
      {
        key: ['g', 'p'],
        type: 'global',
        callback: () => {
          if (!this.checkMenuVisible('kanban')) {
            return;
          }
          this.$router.push('/kanban/list');
          this.$track.send('Hotkeys', {
            Hotkeys_Scope: '全局',
            Hotkeys_Name: 'G+P',
            Hotkeys_Path: this.$route.path,
            Has_Dialog: false
          }, true);
        }
      },
      {
        key: ['g', 's'],
        type: 'global',
        callback: () => {
          if (!this.checkMenuVisible('kanban')) {
            return;
          }
          this.$router.push('/kanban/list');
          this.$track.send('Hotkeys', {
            Hotkeys_Scope: '全局',
            Hotkeys_Name: 'G+S',
            Hotkeys_Path: this.$route.path,
            Has_Dialog: false
          }, true);
        }
      },
      {
        key: ['g', 'b'],
        type: 'global',
        callback: () => {
          if (!this.showSprintMenu) {
            return;
          }
          if (!this.checkMenuVisible('backlog')) {
            return;
          }
          this.$router.push('/backlog/list');
          this.$track.send('Hotkeys', {
            Hotkeys_Scope: '全局',
            Hotkeys_Name: 'G+B',
            Hotkeys_Path: this.$route.path,
            Has_Dialog: false
          }, true);
        }
      },
      {
        key: ['g', 'w'],
        type: 'global',
        callback: () => openWorkList('G+W')
      },
      {
        key: ['g', 'e'],
        type: 'global',
        callback: () => {
          if (!this.isShowEpicMenu) {
            return;
          }
          if (!this.checkMenuVisible('epic')) {
            return;
          }
          this.$router.push('/epic/list');
          this.$track.send('Hotkeys', {
            Hotkeys_Scope: '全局',
            Hotkeys_Name: 'G+E',
            Hotkeys_Path: this.$route.path,
            Has_Dialog: false
          }, true);
        }
      },
      {
        key: ['g', 'e'],
        type: 'global',
        callback: () => {
          if (!this.isShowGanttMenu) {
            return;
          }
          this.$router.push('/project/gantt');
          this.$track.send('Hotkeys', {
            Hotkeys_Scope: '全局',
            Hotkeys_Name: 'G+E',
            Hotkeys_Path: this.$route.path,
            Has_Dialog: false
          }, true);
        }
      },
      {
        key: ['g', 't'],
        type: 'global',
        callback: () => {
          if (!this.checkMenuVisible('team')) {
            return;
          }
          this.$router.push('/team');
          this.$track.send('Hotkeys', {
            Hotkeys_Scope: '全局',
            Hotkeys_Name: 'G+T',
            Hotkeys_Path: this.$route.path,
            Has_Dialog: false
          }, true);
        }
      },
      {
        key: ['g', 'm'],
        type: 'global',
        callback: () => {
          if (!this.checkMenuVisible('roadmap')){
            return;
          }
          this.$router.push('/roadmap');
          this.$track.send('Hotkeys', {
            Hotkeys_Scope: '全局',
            Hotkeys_Name: 'G+M',
            Hotkeys_Path: this.$route.path,
            Has_Dialog: false
          }, true);
        }
      },
      {
        key: ['g', 'r'],
        type: 'global',
        callback: () => {
          if (!this.functionVersionSwitch || !this.checkMenuVisible('version')) {
            return;
          }
          this.$router.push('/release');
          this.$track.send('Hotkeys', {
            Hotkeys_Scope: '全局',
            Hotkeys_Name: 'G+R',
            Hotkeys_Path: this.$route.path,
            Has_Dialog: false
          }, true);
        }
      }
    ];
  },
  data() {
    return {
      // collapse: getCache('left-nav-collapse', 'none') || false,
      apps: new Map(),
      microApps: Object.freeze(microApps),
      currentMicroApp: null,
      asideVisible: null,
      headerVisible: null,
      headerHeight: '50px',
      visibleBanner: false,
      milestoneWorthMsg: null,
      bannerVOS: null,
      isOverseasVersion,
      kanbanPageInstance: null
    };
  },
  computed: {
    ...mapState('app', ['issueImportFrom']),
    ...mapGetters('user', ['showAsideCollapse']),
    ...mapGetters('app', ['checkMenuVisible', 'allMenus']),
    ...mapState('user', ['asideCollapse', 'account']),
    ...mapGetters('features', ['isSwitch']),
    collapse:{
      get(){
        return this.showAsideCollapse;
      },
      set(val){
        this.SET_ASIDE_COLLAPSE(val);
      }
    },
    showHeader() {
      return (isNil(this.headerVisible) ? !this.currentRoute.meta?.hideHeader : this.headerVisible) && !this.isHideModel;
    },
    isWorkListToAirtable() {
      // eslint-disable-next-line
      return this.isSwitch('user:worklist_to_airtable_switch');
    },
    isKeepWorkList() {
      // eslint-disable-next-line
      return this.isSwitch('user:keep_worklist_switch');
    },
    showWorkList(){
      return !(this.isWorkListToAirtable && !this.isKeepWorkList);
    },
    isProjectOverviewActive() {
      return this.currentAppName === 'project' && this.$route.path.startsWith('/project/overview');
    },
    isProjectJenkinsActive() {
      return this.currentAppName === 'project' && this.$route.path.startsWith('/project/cicd');
    },
    importPageFromAirTable(){
      return this.issueImportFrom === 'table' || !this.showWorkList;
    },
    isImportPage(){
      return this.$route.path.startsWith('/work/issue-import');
    },
    isAirTableActive(){
      return this.currentAppName === 'work' && this.$route.path.startsWith('/work/table') || (this.importPageFromAirTable && this.isImportPage);
    },
    showAside() {
      return (isNil(this.asideVisible) ? !this.currentRoute.meta?.hideAside : this.asideVisible) && !this.isHideModel;
    },
    isWorkTableActive(){
      return this.currentAppName === 'work' && this.$route.path.startsWith('/work/table') || (this.importPageFromAirTable && this.isImportPage);
    },
    currentModel(){
      if (this.$route.name === 'release' || this.$route.name === 'release-detail') {
        return 'version';
      }
      if (this.isProjectOverviewActive) {
        return 'overview';
      }
      if (this.isProjectJenkinsActive) {
        return 'cicd';
      }
      if (this.isWorkTableActive) {
        return 'work_list';
      }
      if (this.currentAppName) {
        return this.currentAppName;
      }
      return this.$route.name;
    },
    isHideModel(){
      return !this.checkMenuVisible(this.currentModel) && this.allMenus.find(i => i.switchKey === this.currentModel);
    },
    isValidRoute(){
      return this.$route.name === 'issue-airtable' ? this.isWorkListToAirtable : true;
    },
    renderAside() {
      return this.currentRoute.meta?.share !== true && !this.$store.getters['user/isAnonymous'] && !this.currentRoute.meta?.innerShare;
    },
    isSimple() {
      return (!this.showAside && !this.showHeader) || this.currentRoute.meta?.simple;
    },
    keepAlive() {
      return this.currentRoute.meta?.keepAlive;
    },
    background() {
      return this.currentRoute.meta?.background || '#fff';
    },
    isMicroApp() {
      return !!this.currentMicroApp;
    },
    currentAppName() {
      return this.currentMicroApp?.app?.name;
    },
    currentRoute() {
      return this.$route;
    },
    appValues() {
      return Object.freeze([ ...this.apps.values() ]);
    },
    isShowEpicMenu(){
      return this.$store.getters['features/isCurrentProjectSwitch']('module_epic_switch') && !this.isShowGanttMenu;
    },
    isShowGanttMenu(){
      return this.$store.getters['features/isSwitch']('user:gantt_switch');
    },
    showSprintMenu() {
      return this.$store.getters['features/isCurrentProjectSwitch']('module_sprint_switch');
    },
    functionVersionSwitch() {
      return this.$store.getters['features/isSwitch']('function_version_switch');
    },
    isAnonymous() {
      return this.$store.getters['user/isAnonymous'];
    },
    isSharePage() {
      return this.$route.meta?.share === true;
    },
    /**
     * 看板页面当前选择的迭代
     * @returns {*}
     */
    kanbanCurrentSprint() {
      return this.kanbanPageInstance?.activeSprint;
    }
  },
  watch: {
    currentAppName: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.kanbanPageInstance = null;
          return;
        }
        this.getKanbanInstance();
      }
    }
  },
  created() {
    console.log('🚀🚀🚀 Default Created 🚀🚀🚀');
    start({ singular: false, sandbox: { speedy: true }, excludeAssetFilter: (url) => /http[s]?:\/\/.*\/static\/npm\/.*/.test(url) });
    const prefetchAppList = this.microApps.filter(item => item.prefetch);
    if (prefetchAppList.length) {
      // 这里经验证，只prefetch 当前资源并没有提升，反而会影响后续资源加载速度。故不作调整。
      (window.requestIdleCallback || setTimeout)(() => prefetchApps(prefetchAppList));
    }
  },
  mounted () {
    // 触发微应用的初始化事件，代表spa已经started了
    this.appValues.forEach(app => app.$emit('started'));

    setTimeout(() => showGuideIfNeeded(this), 1000);
    this.queryMilestoneWorthMsg();
    // 导入埋点start
    this.eventBus.$on('issue:import-refresh', this.resetState);
    this.eventBus.$on('issue:emitImportNotice', this.emitImportNotice);
    this.eventBus.$on('issue:emitImportCommentNotice', this.emitImportCommentNotice);
    // 导入埋点end
    menuChannel.addEventListener('message', this.onMenuChannelMessage);

    // 录屏快捷键
    onKeyStroke((e) => {
      const isUserGuide = () => !!document.querySelector('.themes-preview-reflect-backdrop');
      const isSharePage = () => !!document.querySelector('.zk-kanban-share-index');
      const hasDriver = () => {
        const el = document.querySelector('#driver-page-overlay');
        return el && el.style.display !== 'none';
      };
      if (isUserGuide() || isSharePage() || hasDriver()) {
        return;
      }
      // alt + shift + s
      if (e.keyCode === 83 && e.altKey && e.shiftKey) {
        this.eventBus.$emit('recorder:start');
      }
    });
  },
  destroyed() {
    this.eventBus.$off('issue:import-refresh', this.resetState);
    this.eventBus.$off('issue:emitImportNotice', this.emitImportNotice);
    this.eventBus.$off('issue:emitImportCommentNotice', this.emitImportCommentNotice);
    menuChannel.removeEventListener('message', this.onMenuChannelMessage);
  },
  methods: {
    ...mapActions('app', ['loadProjectMember']),
    ...mapMutations('user', ['SET_PRODUCT_RIGHTS', 'SET_ASIDE_COLLAPSE']),
    // 导入埋点start
    handleNoticeClosed(){
      // eslint-disable-next-line
      if (Reflect.has(this.trackData, 'importSucWorkAccount')){
        this.$track.send('Import_success', this.trackData, true);
        return;
      }
      this.$track.send('Import_fail', this.trackData, true);
    },
    resetState(data) {
      this.trackData = data || {};
    },
    emitImportNotice(id){
      this.eventBus.$emit('issue:import-notice', { id, handleNoticeClosed: this.handleNoticeClosed });
    },
    emitImportCommentNotice(id) {
      console.log('[ id ]-453', id);
      this.eventBus.$emit('issue:import-comment-notice', { id, handleNoticeClosed: this.handleNoticeClosed });
    },
    // 导入埋点end
    onMicroActive() {
      this.currentMicroApp = this.appValues.find(item => item.isActive);
    },
    toggleAside(collapse) {
      this.collapse = isNil(collapse) ? !this.asideCollapse : collapse;
    },
    toggleVisibleAside(visible) {
      this.asideVisible = isNil(visible) ? !this.asideVisible : visible;
    },
    toggleVisibleHeader(visible) {
      this.headerVisible = isNil(visible) ? !this.headerVisible : visible;
    },
    async onProjectAccessUpdate() {
      const oldProjectId = this.$store.state.app.currentProject;
      // await this.$store.dispatch('app/refreshProjectList');
      await this.$store.dispatch('app/loadProjects', true);
      this.eventBus.$emit('updateNavProjectList');
      if (oldProjectId) {
        const project = this.$store.getters['app/currentProject'];
        if (!project) {
          if (this.currentAppName) {
            this.$message.info(this.$t('project.noAuth'));
            this.$router.push('/project/list');
            this.eventBus.$emit('issue:force:close');
          }
          this.$store.commit('app/CLEAR_CUR_PROJECT');
        }
      }
    },
    handleClose() {
      this.visibleBanner = false;
    },
    async queryMilestoneWorthMsg() {
      if (this.isSharePage) {
        return;
      }

      this.milestoneWorthMsg = await queryMilestoneWorthMsg();
      if (this.milestoneWorthMsg.hasRead === 0) {
        this.visibleBanner = true;
      }
    },
    async getKanbanInstance() {
      const kanbanApp = document.querySelector('#micro-app_kanban #app');
      if (kanbanApp) {
        this.kanbanPageInstance = findDownComponent(kanbanApp.__vue__, 'KanbanIndex');
      }
    },
    onMenuChannelMessage(data) {
      if (data?.type === 'menuUpdate') {
        this.$store.dispatch('app/updateMenu');
      }
    }
  }
};
</script>

<style lang="scss">
@include b(default-layout) {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  @include e(alert) {
    height: 50px;
    flex-shrink: 0;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    z-index: 10;
  }
  @include e(container) {
    height: 100%;
    flex: 1;
    overflow: hidden;
  }
  @include e(main) {
    height: 100%;
    padding: var(--m-large);
    @include when(simple) {
      padding: 0;
    }
  }
  @include e(wrap) {
    position: relative;
  }
  @include e(wrap-header) {
    @include when(header, 'el-') {
      background: var(--main-bg-color);
      position: relative;
      padding: 0 var(--m-large);
      &:after {
        content: "";
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: var(--color-border-2);
        position: absolute;
      }
    }
  }
}
</style>
